"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no course of given courseId exists
 * @param {string} courseId
 */
class CourseDoesNotExistError extends client_library_1.ExtendableError {
    constructor(courseId) {
        super(`course: ${courseId} does not exist`);
        this.courseId = courseId;
    }
}
exports.default = CourseDoesNotExistError;
//# sourceMappingURL=CourseDoesNotExistError.js.map